var _desc, _defs, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 75,
    height: 43,
    viewBox: "0 0 75 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M42.7144 1C45.48 1 48.1328 2.08008 50.0884 4.00195C52.0439 5.92432 53.1431 8.53174 53.1431 11.25L53.1431 31.75C53.1431 34.4683 52.0439 37.0757 50.0884 38.998C48.1328 40.9199 45.48 42 42.7144 42L11.4287 42C8.6626 42 6.01025 40.9199 4.05469 38.998C2.09863 37.0757 1 34.4683 1 31.75L1 11.25C1 8.53174 2.09863 5.92432 4.05469 4.00195C6.01025 2.08008 8.6626 1 11.4287 1L42.7144 1ZM65.6572 7.1499C66.4316 6.5791 67.353 6.23096 68.3174 6.14551C69.2817 6.06006 70.2515 6.24023 71.1177 6.66602C71.9839 7.0918 72.7119 7.74609 73.2212 8.55566C73.7305 9.36523 74 10.2983 74 11.25L74 31.75C74 32.7017 73.7305 33.6348 73.2212 34.4443C72.7119 35.2539 71.9839 35.9082 71.1177 36.334C70.2515 36.7598 69.2817 36.9399 68.3174 36.8545C67.353 36.769 66.4316 36.4209 65.6572 35.8501L53.1431 26.625L53.1431 16.375L65.6572 7.1499Z",
    stroke: "#FFFFFF",
    strokeOpacity: 1,
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.2084680da5980bfa57e0d07761858d84.svg";
export { ForwardRef as ReactComponent };